<template>
  <v-row align="center" justify="center">
    <v-card max-width="75%" width="500" flat color="background">
      <v-row align="center" justify="center">
        <v-avatar color="withe" size="50">
          <v-icon x-large color="#2196f3">
              mdi-facebook-messenger
          </v-icon>
        </v-avatar>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
export default {};
</script>

<style>
</style>